<template>
	<div id="app">
		<router-view :key="$route.fullPath" @loadMe="loadMe"></router-view>
		<vue-progress-bar></vue-progress-bar>
		<!-- <Footer></Footer> -->
	</div>
</template>

<script>
import gql from "graphql-tag"
import { mapMutations, mapGetters } from "vuex"
import Footer from "@/components/layout/Footer"
import mixins from "@/mixins/mixins"
import listMixins from "@/mixins/listMixins"

export default {
	name: "App",
	components: {
		Footer
	},
	mixins: [mixins, listMixins],
	beforeMount() {
		this.loadMe()
		console.log("NOW DATE", new Date())
		console.log("NOW VUE MOMENT", this.$moment().format("YYYY-MM-DD HH:mm"))
	},
	computed: {
		...mapGetters(["isAuthenticated", "loggedUser"])
	},

	methods: {
		...mapMutations(["logout", "updateLoggedUser"]),
		loadMe() {
			if (this.isAuthenticated) {
				this.$apollo
					.query({
						query: gql`
							query {
								producerLogged {
									id
									name
									lastname
									email
									account {
										id
										name
										email
										currencySymbol
										currency
										taxName
										taxRate
										fee
									}
								}
							}
						`,
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						console.log("NOW API", data.producerLogged.now)
						this.updateLoggedUser(data.producerLogged)
					})
					.catch(() => {
						this.$router.push("/logout")
					})
			} else {
				this.$router.push("/logout")
			}
		}
	}
}
</script>
